import React from 'react';
import styles from './LogoHero.module.css';
import logo from '../../assets/crop_transparent_dark.svg';

const LogoHero: React.FC = () => {
  return (
    <section className={styles.logoHeroSection}>
      <img src={logo} alt="LB Tiling Company Logo" className={styles.logo} />
    </section>
  );
};

export default LogoHero;
